// ================================================================
// Dashboard-Widgets — KPI-Karten (Dashboard/E-Mail/WhatsApp), Today-Timeline,
// AI-Attention-Center + (aktuell ungenutzte) Members/Invitations/Roles-Karten.
// ================================================================
// Herausgelöst aus CompanyDashboard.js (Datei-Split, Runde 3 — 2026-07-19).
// Reine Render-Helfer auf dem geteilten State `s`; can/grad/initials werden
// einmal via initDashboardWidgets() injiziert. Vieles hier ist noch
// Demo-Inhalt (feste Zahlen) — siehe Kommentare an den Funktionen.
import { t } from '../../i18n/index.js';
import { icon, escapeHtml } from '../../utils/dom.js';
import { date as fmtDate } from '../../utils/format.ts';

let s;
let can;
let grad;
let initials;

/** Einmal beim Modul-Start von CompanyDashboard aufrufen. */
export function initDashboardWidgets(ctx) {
  ({ s, can, grad, initials } = ctx);
}

export function kpiCard(ic, bg, glow, value, label, sub, cat) {
  const clickable = cat ? ` cd-kpi-click${s.emailCategory === cat ? ' cd-kpi-active' : ''}" data-action="filter-cat" data-cat="${escapeHtml(cat)}` : '';
  return `
      <div class="cd-kpi ${s.firstDraw ? 'cd-reveal' : ''}${clickable}" style="--cd-kpi-bg:${bg}; --cd-kpi-glow:${glow};">
      <div class="cd-kpi-top">
        <div class="cd-kpi-icon">${icon(ic, 20)}</div>
        <div class="cd-kpi-value">${value}</div>
      </div>
      <div class="cd-kpi-label">${escapeHtml(label)}</div>
      <div class="cd-kpi-sub">${escapeHtml(sub)}</div>
    </div>`;
}

// ── بخش «اطلاعات ایمیل» (فعلاً عددهای دستی؛ بعداً به دیتابیس وصل می‌شود) ──
export function catCount(cat) {
  const src = s.allEmails && s.allEmails.length ? s.allEmails : s.emails;
  return src.filter((m) => m.aiCategory === cat).length;
}

// Kategorie-Schlüssel (Backend-Enum, snake_case) → i18n-Key-Suffix (camelCase).
// Eine Stelle für beide Verwendungen (Filter-Leiste + AI-Kategorie-Badge), statt
// zweier separater, sprachlich hartkodierter Label-Tabellen.
var EMAIL_CAT_KEYS = { opportunity: 'opportunity', invoice: 'invoice', complaint: 'complaint', urgent_request: 'urgentRequest', follow_up: 'followUp', sales_offer: 'salesOffer', supplier: 'supplier', job_application: 'jobApplication', newsletter: 'newsletter', spam: 'spam', other: 'other' };
export function emailCatLabel(cat) {
  var key = EMAIL_CAT_KEYS[cat];
  return key ? t('dashboard.email.cat.' + key) : cat;
}

export function filterBar() {
  if (!s.emailCategory || s.emailCategory === 'all') return '';
  var label = emailCatLabel(s.emailCategory);
  return `<div class="cd-filter-bar">
    <span>${escapeHtml(t('dashboard.email.showing'))} <strong>${escapeHtml(label)}</strong> (${s.emails.length})</span>
    <button class="cd-filter-clear" data-action="filter-cat" data-cat="${escapeHtml(s.emailCategory)}"><span class="cd-filter-x">×</span>${escapeHtml(t('dashboard.email.clearFilter'))}</button>
  </div>`;
}

export function emailKpis() {
  return `
    <section class="cd-kpi-grid cd-kpi-grid-5">
      ${kpiCard('local_fire_department', 'linear-gradient(135deg,#34C759,#10b981)', 'rgba(52,199,89,0.5)',
        catCount('opportunity'), t('dashboard.email.opportunities'),
        t('dashboard.email.opportunitiesSub'), 'opportunity')}
      ${kpiCard('priority_high', 'linear-gradient(135deg,#FF3B30,#ef4444)', 'rgba(255,59,48,0.5)',
        3, t('dashboard.email.urgent'),
        t('dashboard.email.urgentSub'))}
      ${kpiCard('payments', 'linear-gradient(135deg,#FF9500,#f97316)', 'rgba(255,149,0,0.5)',
        catCount('invoice'), t('dashboard.email.invoices'),
        t('dashboard.email.invoicesSub'), 'invoice')}
      ${kpiCard('phone_in_talk', 'linear-gradient(135deg,#3b82f6,#6366f1)', 'rgba(59,130,246,0.5)',
        5, t('dashboard.email.followup'),
        t('dashboard.email.followupSub'))}
      ${kpiCard('sentiment_dissatisfied', 'linear-gradient(135deg,#AF52DE,#8b5cf6)', 'rgba(175,82,222,0.5)',
        catCount('complaint'), t('dashboard.email.unhappy'),
        t('dashboard.email.unhappySub'), 'complaint')}
    </section>`;
}

// ── کارت‌های دسته‌بندی واتساپ (فعلاً عددهای ثابت؛ بعداً به AI/DB وصل می‌شود) ──
export function whatsappKpis() {
  return `
    <section class="cd-kpi-grid cd-kpi-grid-5">
      ${kpiCard('local_fire_department', 'linear-gradient(135deg,#34C759,#10b981)', 'rgba(52,199,89,0.5)',
        8, t('dashboard.email.opportunities'),
        t('dashboard.email.opportunitiesSub'))}
      ${kpiCard('priority_high', 'linear-gradient(135deg,#FF3B30,#ef4444)', 'rgba(255,59,48,0.5)',
        2, t('dashboard.email.urgent'),
        t('dashboard.email.urgentSub'))}
      ${kpiCard('payments', 'linear-gradient(135deg,#FF9500,#f97316)', 'rgba(255,149,0,0.5)',
        1, t('dashboard.email.invoices'),
        t('dashboard.email.invoicesSub'))}
      ${kpiCard('phone_in_talk', 'linear-gradient(135deg,#3b82f6,#6366f1)', 'rgba(59,130,246,0.5)',
        5, t('dashboard.email.followup'),
        t('dashboard.email.followupSub'))}
      ${kpiCard('sentiment_dissatisfied', 'linear-gradient(135deg,#AF52DE,#8b5cf6)', 'rgba(175,82,222,0.5)',
        2, t('dashboard.email.unhappy'),
        t('dashboard.email.unhappySub'))}
    </section>`;
}

export function kpis(active) {
  return `
    <section class="cd-kpi-grid">
      ${kpiCard('groups', 'linear-gradient(135deg,#34C759,#10b981)', 'rgba(52,199,89,0.5)',
        s.members.length, t('dashboard.kpi.members'),
        `${active} ${t('dashboard.kpi.active')}`)}
      ${kpiCard('how_to_reg', 'linear-gradient(135deg,#3b82f6,#6366f1)', 'rgba(59,130,246,0.5)',
        active, t('dashboard.kpi.activeMembers'),
        t('dashboard.kpi.activeSub'))}
      ${kpiCard('admin_panel_settings', 'linear-gradient(135deg,#AF52DE,#8b5cf6)', 'rgba(175,82,222,0.5)',
        s.roles.length, t('dashboard.kpi.roles'),
        t('dashboard.kpi.rolesSub'))}
      ${kpiCard('mail', 'linear-gradient(135deg,#FF9500,#f97316)', 'rgba(255,149,0,0.5)',
        s.invitations.length, t('dashboard.kpi.invitations'),
        t('dashboard.kpi.invitationsSub'))}
    </section>`;
}

export function membersCard(u) {
  const me = u || {};
  let rows;
  if (s.loading) rows = `<div class="cd-muted">${escapeHtml(t('dashboard.loading'))}</div>`;
  else if (!s.members.length) rows = `<div class="cd-empty">${escapeHtml(t('dashboard.noMembers'))}</div>`;
  else rows = s.members.slice(0, 6).map((m) => memberRow(m, me)).join('');

  const addBtn = can('members:invite')
    ? `<button class="cd-btn-ghost" data-action="invite">${icon('add', 14)}${escapeHtml(t('dashboard.add'))}</button>` : '';
  const footer = can('members:read')
    ? `<div class="cd-card-foot"><button class="cd-link" data-action="open-members">${escapeHtml(t('dashboard.manageMembers'))}</button></div>` : '';

  return `
    <div class="cd-card">
      <div class="cd-card-head">
        <div>
          <div class="cd-card-title">${escapeHtml(t('dashboard.membersTitle'))}</div>
          <div class="cd-card-sub">${escapeHtml(t('dashboard.membersSub'))}</div>
        </div>
        ${addBtn}
      </div>
      <div>${rows}</div>
      ${footer}
    </div>`;
}

export function memberRow(m, me) {
  const isSelf = me && m.id === me.id;
  const roleName = m.role ? m.role.name : t('dashboard.noRole');
  const roleCls = m.role ? 'cd-badge' : 'cd-badge cd-norole';
  const isActive = m.status === 'ACTIVE';
  const statusCls = isActive ? 'cd-active' : 'cd-disabled';
  const statusTxt = isActive ? t('dashboard.statusActive') : t('dashboard.statusDisabled');
  return `
    <div class="cd-member-row">
      <div class="cd-ava" style="background:${grad(m.name || m.email)};">${escapeHtml(initials(m.name, m.email))}</div>
      <div>
        <div class="cd-m-name">${escapeHtml(m.name || m.email)} ${isSelf ? `<span class="cd-you">(${escapeHtml(t('dashboard.you'))})</span>` : ''}</div>
        <div class="cd-m-email">${escapeHtml(m.email)}</div>
      </div>
      <span class="${roleCls}">${escapeHtml(roleName)}</span>
      <span class="cd-status ${statusCls}"><span class="cd-dot"></span>${escapeHtml(statusTxt)}</span>
    </div>`;
}

export function invitationsCard() {
  let rows;
  if (s.loading) rows = `<div class="cd-muted">${escapeHtml(t('dashboard.loading'))}</div>`;
  else if (!s.invitations.length) rows = `<div class="cd-empty">${escapeHtml(t('dashboard.noInvitations'))}</div>`;
  else rows = s.invitations.map(invRow).join('');

  return `
    <div class="cd-card">
      <div class="cd-card-head">
        <div class="cd-card-title">${escapeHtml(t('dashboard.invitationsTitle'))}</div>
        <div class="cd-card-meta">${s.invitations.length} ${escapeHtml(t('dashboard.pending'))}</div>
      </div>
      <div>${rows}</div>
      ${can('members:invite') ? `<div class="cd-card-foot"><button class="cd-link" data-action="open-members">${escapeHtml(t('dashboard.manageInvitations'))}</button></div>` : ''}
    </div>`;
}

export function invRow(inv) {
  const when = fmtDate(inv.expiresAt);
  const roleName = inv.role ? inv.role.name : t('dashboard.noRole');
  return `
    <div class="cd-row">
      <div>
        <div class="cd-row-main">${escapeHtml(inv.email)}</div>
        <div class="cd-row-sub">${escapeHtml(roleName)}${when ? ' · ' + escapeHtml(t('dashboard.expires')) + ' ' + escapeHtml(when) : ''}</div>
      </div>
      <span class="cd-badge cd-norole">${escapeHtml(t('dashboard.pendingBadge'))}</span>
    </div>`;
}

export function rolesCard() {
  let rows;
  if (s.loading) rows = `<div class="cd-muted">${escapeHtml(t('dashboard.loading'))}</div>`;
  else if (!s.roles.length) rows = `<div class="cd-empty">${escapeHtml(t('dashboard.noRoles'))}</div>`;
  else rows = s.roles.slice(0, 6).map(roleRow).join('');

  return `
    <div class="cd-card">
      <div class="cd-card-head">
        <div class="cd-card-title">${escapeHtml(t('dashboard.rolesTitle'))}</div>
        ${can('roles:write') ? `<button class="cd-link" data-action="open-roles">${escapeHtml(t('dashboard.newRole'))}</button>` : ''}
      </div>
      <div>${rows}</div>
      ${can('roles:read') ? `<div class="cd-card-foot"><button class="cd-link" data-action="open-roles">${escapeHtml(t('dashboard.manageRoles'))}</button></div>` : ''}
    </div>`;
}

export function roleRow(r) {
  const count = r._count ? r._count.users : 0;
  const permCount = r.permissions ? r.permissions.length : 0;
  return `
    <div class="cd-role-row">
      <div class="cd-role-ic" style="background:${grad(r.name)};">${icon('shield', 17)}</div>
      <div>
        <div class="cd-role-name">${escapeHtml(r.name)}</div>
        <div class="cd-role-desc">${escapeHtml(r.description || (permCount + ' ' + t('dashboard.permsCount')))}</div>
      </div>
      <div class="cd-role-count">${count} ${escapeHtml(t('dashboard.usersCount'))}</div>
    </div>`;
}

export function servicesCard() {
  return `
    <div class="cd-card">
      <div class="cd-card-head">
        <div class="cd-card-title">${escapeHtml(t('dashboard.servicesTitle'))}</div>
      </div>
      <div style="padding:18px 20px; display:flex; flex-direction:column; gap:12px;">
        <div style="font-size:13px; color:var(--cd-text-2); line-height:1.6;">
          ${escapeHtml(t('dashboard.servicesInfo'))}
        </div>
        <div style="font-size:12px; color:var(--cd-text-4);">
          ${escapeHtml(t('dashboard.servicesSoon'))}
        </div>
      </div>
    </div>`;
}


// ================================================================
// Today Timeline + AI Attention Center
// Demo / manual content; later wired to the database.
// ================================================================
const TL_START = 7 * 60, TL_END = 18 * 60, TL_SPAN = TL_END - TL_START;
const TL_NOW = 10 * 60 + 30; // 10:30 (demo)
export function tlPct(min) { return ((min - TL_START) / TL_SPAN) * 100; }
export function tlTime(min) { const h = Math.floor(min / 60), m = min % 60; return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0'); }

const TL_WORKERS = [
  { name: 'Ali', role: 'Electrician', av: '#3b82f6,#6366f1', tasks: [
    { st: 480, en: 660, cat: 'job', name: 'Install Lighting', sub: 'M\u00fcller GmbH' },
    { st: 780, en: 990, cat: 'job', name: 'Emergency Repair', sub: 'Schneider AG' } ] },
  { name: 'Reza', role: 'Plumber', av: '#34C759,#10b981', tasks: [
    { st: 540, en: 720, cat: 'inst', name: 'Bathroom Installation', sub: 'Weber Family' },
    { st: 810, en: 1020, cat: 'inst', name: 'Pipe Repair', sub: 'Keller Residence' } ] },
  { name: 'Mohammad', role: 'HVAC Technician', av: '#AF52DE,#8b5cf6', tasks: [
    { st: 450, en: 720, cat: 'svc', name: 'HVAC Service', sub: 'Office Building' },
    { st: 780, en: 960, cat: 'svc', name: 'Maintenance', sub: 'TechPark' } ] },
  { name: 'Sina', role: 'Apprentice', av: '#FF9F45,#FF7A1A', tasks: [
    { st: 540, en: 720, cat: 'other', name: 'Assistant', sub: 'Team Support' },
    { st: 780, en: 1080, cat: 'avail', name: '', sub: 'Available from 13:00' } ] },
  { name: 'Lukas', role: 'Roofer', av: '#06b6d4,#3b82f6', tasks: [
    { st: 510, en: 690, cat: 'job', name: 'Roof Inspection', sub: 'Bauer GmbH' },
    { st: 840, en: 1020, cat: 'inst', name: 'Gutter Repair', sub: 'Hofmann AG' } ] },
];

// Parameter heisst bewusst `task` und nicht `t` \u2014 sonst verdeckt er die i18n-Funktion.
export function tlTaskHtml(task) {
  const left = tlPct(task.st), width = tlPct(task.en) - tlPct(task.st);
  if (task.cat === 'avail') {
    return `<div class="cd-tl-task cd-tl-avail" style="left:${left}%;width:${width}%;"><span class="cd-tl-sub">${escapeHtml(task.sub)}</span></div>`;
  }
  return `
    <div class="cd-tl-task cd-tl-${task.cat}" style="left:${left}%;width:${width}%;">
      <div class="cd-tl-time">${tlTime(task.st)} \u2013 ${tlTime(task.en)}</div>
      <div class="cd-tl-name">${escapeHtml(task.name)}</div>
      <div class="cd-tl-sub">${escapeHtml(task.sub)}</div>
    </div>`;
}

export function tlRowHtml(w) {
  return `
    <div class="cd-tl-row">
      <div class="cd-tl-worker">
        <div class="cd-tl-ava" style="background:linear-gradient(135deg,${w.av});">${escapeHtml(String(w.name).slice(0, 1).toUpperCase())}</div>
        <div class="cd-tl-wmeta">
          <div class="cd-tl-wname">${escapeHtml(w.name)}</div>
          <div class="cd-tl-wrole">${escapeHtml(w.role)}</div>
        </div>
      </div>
      <div class="cd-tl-track">
        <div class="cd-tl-now" style="left:${tlPct(TL_NOW)}%;"></div>
        ${w.tasks.map(tlTaskHtml).join('')}
      </div>
    </div>`;
}

export function todayTimeline() {
  const ticks = [420, 540, 780, 900, 1020, 1080];
  const axis = ticks.map((m) => {
    let pos = `left:${tlPct(m)}%;transform:translateX(-50%);`;
    if (m <= TL_START) pos = 'left:0;transform:none;';
    if (m >= TL_END) pos = 'left:100%;transform:translateX(-100%);';
    return `<span class="cd-tl-tick" style="${pos}">${tlTime(m)}</span>`;
  }).join('') + `<span class="cd-tl-nowpill" style="left:${tlPct(TL_NOW)}%;">${tlTime(TL_NOW)}</span>`;

  const legend = `
    <div class="cd-tl-legend">
      <span class="cd-leg"><span class="cd-leg-dot" style="background:#3b82f6;"></span>Job</span>
      <span class="cd-leg"><span class="cd-leg-dot" style="background:#34C759;"></span>Installation</span>
      <span class="cd-leg"><span class="cd-leg-dot" style="background:#AF52DE;"></span>Service</span>
      <span class="cd-leg"><span class="cd-leg-dot" style="background:#f59e0b;"></span>Other</span>
      <span class="cd-leg"><span class="cd-leg-dot cd-leg-avail"></span>Available</span>
    </div>`;

  return `
    <div class="cd-card">
      <div class="cd-card-head">
        <div class="cd-card-head-l">
          <div class="cd-tl-headic">${icon('calendar_today', 18)}</div>
          <div class="cd-card-title">Today Timeline</div>
        </div>
        <div class="cd-tl-pill">Today ${icon('expand_more', 16)}</div>
      </div>
      <div class="cd-tl-body">
        <div class="cd-tl-axis"><div></div><div class="cd-tl-axis-track">${axis}</div></div>
        ${TL_WORKERS.map(tlRowHtml).join('')}
        ${legend}
      </div>
    </div>`;
}

const AI_ALERTS = [
  { tone: 'amber', badgeTone: 'amber', ic: 'warning', name: 'M\u00fcller GmbH', badge: 'Quote sent 5 days ago', desc: 'No response from customer', rec: 'Call customer today', btn: 'Call' },
  { tone: 'red', badgeTone: 'red', ic: 'request_quote', name: 'Schneider AG', badge: 'Invoice overdue', desc: 'CHF 2,400 is overdue by 7 days', rec: 'Send reminder', btn: 'Send' },
  { tone: 'orange', badgeTone: 'gray', ic: 'phone_in_talk', name: 'Keller Residence', badge: 'No answer', desc: 'Called 3 times, no answer', rec: 'Call immediately', btn: 'Call' },
];

export function aiAlertHtml(a) {
  return `
    <div class="cd-ai-alert">
      <div class="cd-ai-ic cd-ai-${a.tone}">${icon(a.ic, 19)}</div>
      <div class="cd-ai-body">
        <div class="cd-ai-row1">
          <span class="cd-ai-name">${escapeHtml(a.name)}</span>
          <span class="cd-ai-badge cd-ai-badge-${a.badgeTone}">${escapeHtml(a.badge)}</span>
        </div>
        <div class="cd-ai-desc">${escapeHtml(a.desc)}</div>
        <div class="cd-ai-rec cd-ai-rec-${a.tone}"><b>Recommended:</b> <span>${escapeHtml(a.rec)}</span></div>
      </div>
      <button class="cd-ai-btn cd-ai-${a.tone}">${escapeHtml(a.btn)}</button>
    </div>`;
}

export function aiAttentionCard() {
  return `
    <div class="cd-card">
      <div class="cd-card-head">
        <div class="cd-card-head-l">
          <div class="cd-ai-headic">${icon('auto_awesome', 18)}</div>
          <div class="cd-card-title">AI Attention Center</div>
        </div>
      </div>
      <div class="cd-ai-list">
        ${AI_ALERTS.map(aiAlertHtml).join('')}
      </div>
      <div class="cd-ai-foot"><button class="cd-link cd-ai-viewall">View all alerts ${icon('arrow_forward', 15)}</button></div>
    </div>`;
}


